import SearchableDropdown, {
  SearchableDropdownProps
} from '@components/searchable-dropdown/SearchableDropdown';
import TagSelector from '@components/tag-selector/TagSelector';
import useNotify from '@hooks/notify';
import { Tag } from 'types/lead-management';

interface TagInputProps {
  value: string;
  onChange: (value: string) => void;
  onTagsChange: (tags: Tag[], type: 'add' | 'remove') => void;
  selectedTags: Tag[];
  tagOptions?: Tag[];
  onUpdateTag?: (tag: Tag) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  searchIcon?: React.ReactNode;
  hideChevron?: boolean;
  renderSelectedBelow?: boolean;
  selectorProps?: Record<string, any>;
  renderChip?: SearchableDropdownProps<Tag>['renderChip'];
  chipPosition?: 'top' | 'bottom';
  defaultTagColor?: string;
  showSelectionTooltip?: boolean;
}

const TagSelectorWrapper = ({
  onSelectItem,
  onCreateItem,
  onUpdateItem,
  selectedItems,
  itemOptions,
  showSelectionTooltip,
  ...otherProps
}: any) => (
  <TagSelector
    {...otherProps}
    onSelectTag={onSelectItem}
    onCreateTag={onCreateItem}
    onUpdateTag={onUpdateItem}
    selectedTags={selectedItems}
    tagOptions={itemOptions}
    showSelectionTooltip={showSelectionTooltip}
  />
);

const TagInput = ({
  value,
  onChange,
  onTagsChange,
  selectedTags,
  tagOptions = [],
  onUpdateTag,
  placeholder = 'Select/Search Tag',
  className = '',
  disabled = false,
  searchIcon,
  hideChevron,
  renderSelectedBelow,
  selectorProps,
  renderChip,
  chipPosition,
  defaultTagColor = '#F2E1E9',
  showSelectionTooltip = false
}: TagInputProps) => {
  const { createErrorAlert } = useNotify();

  const handleCreateTag = (tagName: string, color?: string): Tag => ({
    id: `custom-${Date.now()}`,
    name: tagName,
    color: color || defaultTagColor
  });

  const validateNameLength = (name: string) => {
    if (name.length < 3 || name.length > 15) {
      createErrorAlert('Name must be between 3 and 15 characters');
      return false;
    }
    return true;
  };

  return (
    <SearchableDropdown<Tag>
      value={value}
      onChange={onChange}
      onItemsChange={onTagsChange}
      selectedItems={selectedTags}
      availableItems={tagOptions}
      onUpdateItem={onUpdateTag}
      onCreateItem={handleCreateTag}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      allowCreate
      allowMultiple
      searchIcon={searchIcon}
      hideChevron={hideChevron}
      renderChip={renderChip}
      chipPosition={chipPosition}
      SelectorComponent={TagSelectorWrapper}
      validateNameLength={validateNameLength}
      renderSelectedBelow={renderSelectedBelow}
      selectorProps={selectorProps}
      defaultTagColor={defaultTagColor}
      showSelectionTooltip={showSelectionTooltip}
    />
  );
};

export default TagInput;
